export default {
  center: {
    textAlign: 'center'
  },
  checkbox: {
    height: '20px',
    width: '20px',
    borderRadius: '4px'
  },
  date: {
    width: '80px'
  },
  status: {
    width: '30px',
    height: '30px',
    borderRadius: '30px'
  },
  contextMenu: {
    width: '40px',
    height: '40px',
    borderRadius: '5px',
    display: 'block'
  }
}
